import React from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/system';
import { HEADER } from 'styles/constants/appearanceSectionNames';
import { getButtonBackgroundHoverColor } from 'styles/helpers/getThemeStyles';

const MenuLinkContainer = styled('span')({
  display: 'flex',
  alignItems: 'center',
  marginRight: '-12px',
  '&:hover': {
    cursor: 'pointer',
    opacity: '0.7'
  }
});

const MenuName = styled(Typography)(({ theme }) => {
  return {
    color: getButtonBackgroundHoverColor(theme)
  };
});

const StyledExpandMoreIcon = styled(ExpandMoreIcon)(({ theme }) => ({
  fill: getButtonBackgroundHoverColor(theme)
}));

function DropdownLink({ label, onClick }) {
  const styles = { variant: HEADER };
  return (
    <Button onClick={onClick}>
      <MenuLinkContainer>
        <MenuName {...styles}>{label}</MenuName>
        <StyledExpandMoreIcon data-testid={'dropdown-icon'} />
      </MenuLinkContainer>
    </Button>
  );
}

DropdownLink.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default DropdownLink;
